import React from "react";
import { Group, ActionIcon, Text, Box } from "@mantine/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import FilterDefinitionEditor from "./FilterDefinitionEditor";

import { displayEmoji } from "../../../../utils/Emoji";

export default function FilterSortableItem({
  id,
  label,
  emojicon,
  slug,
  type,
  allFilters,
  handlers,
  selectedProperty,
  setSelectedProperty,
  onEdit
}) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <>
      <Group ref={setNodeRef} style={style} spacing={0} p="xs" bg="gray.0" position="apart">
        <Box style={{ width: 16 }} mr={14} align="center">
          {displayEmoji(emojicon, "grey")}
        </Box>
        <Text style={{ flex: 1 }}>{label}</Text>
        <Group spacing={0}>
          <ActionIcon onClick={() => onEdit()} zIndex={7000}>
            <FontAwesomeIcon icon={solid("cog")} size="sm" />
          </ActionIcon>
          <ActionIcon {...listeners} {...attributes}>
            <FontAwesomeIcon icon={solid("grip-vertical")} size="sm" />
          </ActionIcon>
        </Group>
      </Group>
      <FilterDefinitionEditor
        slug={slug}
        type={type}
        allFilters={allFilters}
        handlers={handlers}
        selectedProperty={selectedProperty}
        setSelectedProperty={setSelectedProperty}
        onClose={() => onEdit(true)}
      />
    </>
  );
};